import type { Translation } from "~/types/i18n";

export const ko: Translation = {
  nav: {
    top: "TOP",
    pv: "PV",
    introduction: "INTRODUCTION",
    character: "CHARACTER",
    news: "NEWS",
    goods: "GOODS",
    onair: "ON AIR",
    special: "SPECIAL",
  },
  hero: {
    comingSoon: "방송·배신 정보 곧 공개",
    scrollDown: "SCROLL",
  },
  pv: {
    title: "PV",
    subtitle: "프로모션 비디오",
  },
  synopsis: {
    title: "STORY",
    subtitle: "줄거리",
  },
  characters: {
    title: "CHARACTER",
    subtitle: "캐릭터 소개",
    cv: "성우",
  },
  news: {
    title: "NEWS",
    subtitle: "최신 소식",
    new: "NEW",
    noNews: "뉴스가 없습니다",
  },
  md: {
    title: "MD",
    subtitle: "공식 굿즈",
    visitStore: "스토어 방문",
    goBack: "돌아가기",
    viewDetail: "자세히 보기",
    buyNow: "구매하러 가기",
  },
  onair: {
    title: "ON AIR",
    subtitle: "방영 정보",
  },
  special: {
    title: "SPECIAL",
    subtitle: "스페셜 콘텐츠",
  },
  footer: {
    policy: "개인정보처리방침",
    originals: "Laftel Originals",
    contact: "문의하기",
    share: "X에서 공유",
    copyright: "© 2025 Laftel Inc. All Rights Reserved.",
  },
  cta: {
    comingSoon: "준비중",
  },
  home: {
    heroSubtitle: "라프텔이 만드는 오리지널 애니메이션",
    aboutTitle: "널리 덕후를 이롭게",
    aboutDescription:
      "라프텔은 서브컬처 IP를 기반으로\n애니메이션 제작과 투자, 굿즈 및 오프라인 사업을 아우르며\n애니메이션 생태계의 다양성을 확장합니다.\n라프텔 오리지널이 발굴한 다채로운 이야기를 통해,\n당신을 기다리는 새로운 콘텐츠의 세계를 온전히 경험해 보세요",
    worksTitle: "오리지널 작품",
    comingSoon: "COMING SOON",
    navAbout: "ABOUT",
    navWorks: "WORKS",
    watchOnYoutube: "YouTube에서 보기",
  },
};
